export default [
  {
    name: 'ポーランド語',
    level: '母国語',
    percent: 100,
    flag: 'https://flagcdn.com/w40/pl.png',
  },
  {
    name: '英語',
    level: 'C1',
    percent: 80,
    flag: 'https://flagcdn.com/w40/us.png',
    certs: [{ level: '', link: '/certs/english-b2.pdf' }],
  },
  // {
  //   name: 'ノルウェー語',
  //   level: 'B1+',
  //   percent: 60,
  //   flag: 'https://flagcdn.com/w40/no.png',
  // },
  // {
  //   name: 'アイスランド語',
  //   level: 'B1',
  //   percent: 50,
  //   flag: 'https://flagcdn.com/w40/is.png',
  // },
  {
    name: 'ドイツ語',
    level: 'A2+',
    percent: 35,
    flag: 'https://flagcdn.com/w40/de.png',
  },
  {
    name: '日本語',
    level: 'A2',
    percent: 25,
    flag: 'https://flagcdn.com/w40/jp.png',
  },
  // {
  //   name: 'クロアチア語',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/hr.png',
  // },
  // {
  //   name: 'ロシア語',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/ru.png',
  // },
]
